<div *ngIf="params.data.destinationName === null || params.data.displayStatus === 'PENDING' || params.data.warehouseError" class="border-left-5"></div>
<div class="row mr-0 base-style integration-name {{( (['ENABLED', 'UPDATED', 'DELETED', 'PAUSED'].includes(params.data.status) && !isDestination) &&
!(params.data.destinationName === null || params.data.displayStatus === 'PENDING' || params.data.warehouseError)
 ? 'cursor-pointer':'')}} {{(['PAUSED', 'DELETED'].includes(params.data.status)) ? 'faded' : ''}}"
    (click)="$event.stopPropagation(); (params.data.status !== 'DELETED' && !isDestination) && routeToDetails()" >
    <img class="image-1-src" *ngIf="isDestination === true" src="../../assets/images/datawarehouselogos/{{params.data.logoUrl}}.png"  />
    <img class="image-1-src" *ngIf="isDestination !== true" src="../../assets/images/source-logos/pngFormat/{{params.data.logoUrl }}"  />
      <div class="name-chip-container">
        <div class="basic-margin grid-cell text-capitalize ellipsis"  [ngClass]="{'align-top': params.data.lastSyncStatus === 'action required'}"> {{params.value }} </div>
        <div class="plan-status-container">
          <app-chip class="plan-chip" *ngIf="showChip(params?.data?.associatedPlan, userPlan)" [show]="showChip(params?.data?.associatedPlan, userPlan)" [planType]="params?.data?.associatedPlan" [userPlan]="userPlan"></app-chip>
          <div *ngIf="params.data.lastSyncStatus === 'action required'" class="status-chip">
            Jobs interrupted due to errors
            <img src="../../assets/images/svg/action-required.svg">
          </div>
        </div>
      </div>
    <i class="icon dripicons-information des-icon" *ngIf="params.data.description !== '' && params.data.description !== undefined" [matTooltip]="params.data.description"></i>
    <span class="template-badge" matTooltip="Template" *ngIf="params.data.template === true">T</span>
</div>


<ng-container *ngIf="params.data.destinationName === null || params.data.displayStatus === 'PENDING' || params.data.warehouseError">
    <div class="row {{(['ENABLED', 'UPDATED', 'DELETED', 'PAUSED'].includes(params.data.status)?'cursor-pointer':'')}}"
      (click)="$event.stopPropagation(); !innerClicked && routeToDetails()">

      <div class="individual-cell-renderer alert alert-error-pending alert-custom-sty" *ngIf="params.data.destlogoUrl === null">
        <div class="alert-body">
          <div class="alert-icon ptop-2">
            <img src="../../assets/images/icons/alert.svg">
          </div>
          <div class="alert-message error-color">
                Destination mapping is pending, complete the mapping and start replicating the data.
            </div>
        </div>
      </div>

      <div class="individual-cell-renderer alert  {{(params.data.status === 'UPDATED')?'alert-message': 'alert-error-pending' }} alert-custom-sty"
        *ngIf="params.data.destlogoUrl !== null ">
        <div class="alert-body ptop-2">
          <div class="alert-icon">
            <img src="../../assets/images/icons/alert.svg">
          </div>
          <div class="alert-message error-color" *ngIf="params.data.status === 'CREATED'">
            The sync status of the integration will change once Daton creates tables in the warehouse and schedules jobs.
            This will take a few minutes.
          </div>
          <div class="alert-message error-color" *ngIf="params.data.status === 'ENABLED'">
            Configuration failed for the source
          </div>
          <div class="alert-message info-color" *ngIf="params.data.status === 'UPDATED'">
            Daton will process the requested modifications to the source, shortly.
          </div>
        </div>
      </div>
    </div>
</ng-container>
